import styled from 'styled-components'

import { colors } from '@styles/vars/colors.style'
import { mq } from '@styles/vars/media-queries.style'
import { clamp } from "@styles/utils/conversion.style";

export const MissionMain = styled.section`
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  background-color: ${colors.black};
  color: ${colors.white};

  ${mq.tabletL} {
    height: 100vh;
    max-height: 100vh;
  }
`

export const MissionBackground = styled.div`
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
  pointer-events: none;

  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    object-position: center;
  }
`

export const MissionVideo = styled.video`
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  object-position: center;
`

export const MissionOverlay = styled.div`
  position: absolute;
  inset: 0;
  background:
    linear-gradient(
      90deg,
      rgba(0, 0, 0, 0.78) 0%,
      rgba(0, 0, 0, 0.3) 48%,
      rgba(0, 0, 0, 0.72) 100%
    ),
    linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.24) 0%,
      rgba(0, 0, 0, 0.08) 45%,
      rgba(0, 0, 0, 0.52) 100%
    );
`

export const MissionContent = styled.div`
  position: relative;
  z-index: 1;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding-top: clamp(6rem, 9vh, 11rem);
  padding-bottom: clamp(5rem, 8vh, 9rem);

  ${mq.tabletL} {
    height: 100vh;
    max-height: 100vh;
  }
`

export const MissionHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const MissionTitle = styled.h2`
  margin: 0;
  color: ${colors.pastelGreen};
  font-size: clamp(5rem, 5vw, 8.4rem);
  font-weight: 400;
  transform-origin: left center;
  will-change: transform, opacity;

  ${clamp("font-size", 32, 48)};
  font-family: Signifier;
  strong {
      font-family: National2;
      font-weight: 900;
      display: block;
  }
`

export const MissionSubtitle = styled.p`
  max-width: 90rem;
  margin: clamp(8rem, 14vh, 16rem) 0 0;
  color: ${colors.white};
  font-size: clamp(2.6rem, 2.4vw, 4rem);
  font-weight: 400;
  will-change: transform, opacity;

  ${mq.tabletL} {
    margin-top: 130px;
  }
`

export const MissionList = styled.ul`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  gap: 4rem;
  margin: clamp(6rem, 10vh, 12rem) 0 0;
  padding: 0;
  list-style: none;

  ${mq.tabletL} {
    flex: 1;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    align-items: flex-start;
    gap: clamp(2rem, 2vw, 4rem);
    margin-top: 20px;
    padding-top: clamp(5rem, 8vh, 9rem);
  }
`

export const MissionItem = styled.li`
  min-width: 0;
  margin: 0;
  padding: 0;
  color: ${colors.white};
  opacity: 1;
  visibility: visible;
  transform: none;
  transition:
    color 250ms ease,
    transform 250ms ease;
  will-change: transform, opacity;

  &:hover {
    color: ${colors.pastelGreen};
    transform: translateY(-0.4rem);
  }

  &:hover > div:first-child {
    background-color: ${colors.pastelGreen};
    transform: scaleX(1);
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;

    &:hover {
      transform: none;
    }
  }

  ${mq.tabletL} {
    opacity: 0;
  }
`;

export const MissionItemLine = styled.div`
  width: 100%;
  height: 0.2rem;
  margin-bottom: clamp(2rem, 2.4vw, 3.2rem);
  background-color: currentColor;
  transform: scaleX(1);
  transform-origin: left center;
  transition:
    background-color 250ms ease,
    transform 250ms ease;
`

export const MissionItemContent = styled.div`
  max-width: 30rem;
  color: inherit;
  font-size: clamp(2.3rem, 1.8vw, 3.2rem);
  font-weight: 400;

  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
    color: inherit;
    font: inherit;
  }

  p + p {
    margin-top: 1em;
  }

  strong {
    color: inherit;
    font-weight: 700;
  }

  em {
    font-style: italic;
  }

  ul,
  ol {
    margin: 1em 0 0;
    padding-left: 1.2em;
  }

  li + li {
    margin-top: 0.5em;
  }

  a {
    color: inherit;
    text-decoration: underline;
    text-underline-offset: 0.15em;
  }

  ${mq.tabletL} {
    max-width: 100%;
  }
`